
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { DocumentCard } from "./DocumentCard";

interface DocumentsListProps {
  documents: any[];
  loading: boolean;
  onViewDocument: (document: any) => void;
}

export function DocumentsList({
  documents,
  loading,
  onViewDocument,
}: DocumentsListProps) {
  if (documents.length === 0) return null;

  return (
    <div className="mt-8">
      <h2 className="text-xl font-bold mb-4">
        Your Verification Documents
      </h2>
      {loading ? (
        <div className="space-y-3">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      ) : (
        <div className="space-y-3">
          {documents.map((doc) => (
            <DocumentCard
              key={doc.id}
              document={doc}
              onViewDocument={onViewDocument}
            />
          ))}
        </div>
      )}
    </div>
  );
}
